<template>
  <div class="container bg-hui">
    <div class="QA-font">
      <dl>
        <dt>Q: 什么是钱包余额？</dt>
        <dd>A: 钱包余额是您在万顺代驾司机端中可以进行提现的收入。钱包余额是由车费收入、奖励、提现、补款、提现失败返还、异常订单扣款等费用计算而成。</dd>
      </dl>
      <dl>
        <dt>Q:如何进行提现？</dt>
        <dd>A:提现日可以在【我的钱包-余额-提现】中输入本人一类银行卡，提现金额并通过验证进行提现。</dd>
      </dl>
      <dl>
        <dt>Q: 提现多久到账？</dt>
        <dd>A: 正常情况下提现申请后平台下周三审核通过，提交到银行后一般24小时内到账。若提交申请后超时平台未处理或者提交到银行未到账，请联系万顺车主客服。</dd>
      </dl>
      <dl>
        <dt>Q:提现失败了怎么办？</dt>
        <dd>A:若提现失败了，资金会退回至你的钱包余额，可以在余额明细中查看记录，你可以再次发起提现。</dd>
      </dl>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    mounted() {
    },
    methods: {},
  };
</script>
<style scoped lang="less">
  .QA-font {
    dl {
      background: #ffffff;
      margin: 0.75rem 0.75rem 0px 0.75rem;

      dt {
        font-size: 1rem;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 1rem;
        border-bottom: solid 1px #EBEBEB;
        padding: 0.875rem 1rem;;
      }

      dd {
        font-size: 1rem;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 24px;
        padding: 0.5625rem 0.75rem 0.75rem 0.75rem;
      }
    }
  }
</style>

